import React from 'react'
import ClearIcon from '@material-symbols/svg-300/rounded/close.svg'

import Button from '../Button/Button'

const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')!.set!

const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
  const input = e.currentTarget.parentElement?.querySelector('input')
  if (input) {
    nativeInputValueSetter.call(input, '')
    input.dispatchEvent(new Event('input', { bubbles: true }))
    input.focus()
  }
}

export default React.memo(function ClearTextInput() {
  return (
    <Button tiny onClick={handleClick} color="var(--text-grey)">
      <ClearIcon />
    </Button>
  )
})
